import { useParams } from 'react-router';
import { EmptyTableResults } from '@/components/Table/styles';
import { ORGANIZATIONS_USERS_TABLE_CONFIG } from '../const/const';
import { TableType } from '@/components/Table/types/types';
import { OrganizationUserType } from '@/bundle/_Opco/types/types';
import { NoResults } from '@/components/NoResults/NoResults';
import NoUsersIcon from '@/images/NoUsersIcon.svg?react';
import { getOrganizationUserDetailsPath } from '../Details/path/path';
import { useStatefulNavigation } from '@/hooks/useStatefulNavigation';
import { useResponsiveDevice } from '@/hooks/useResponsiveDevice';
import { MobileTable } from '@/components/Table/MobileTable/MobileTable';
import { DesktopTable } from '@/components/Table/DesktopTable';

export const OrganizationUsersTable = ({ items = [], isLoading }: TableType<OrganizationUserType>) => {
  const { isMobile } = useResponsiveDevice();
  const { navigateFrom } = useStatefulNavigation();
  const { id } = useParams();

  const hasItems = !!items.length;
  const noItems = !hasItems && !isLoading;

  const navigateToUserDetails = (item: OrganizationUserType) => {
    const url = getOrganizationUserDetailsPath(id, item?.id);

    navigateFrom(url);
  };

  if (noItems) {
    return (
      <EmptyTableResults>
        <NoResults icon={<NoUsersIcon />} message='Please create your first user.' />
      </EmptyTableResults>
    );
  }

  return (
    hasItems &&
    (isMobile ? (
      <MobileTable
        config={ORGANIZATIONS_USERS_TABLE_CONFIG}
        items={items}
        isLoading={isLoading}
        onRowClick={navigateToUserDetails}
      />
    ) : (
      <DesktopTable
        config={ORGANIZATIONS_USERS_TABLE_CONFIG}
        items={items}
        isLoading={isLoading}
        onRowClick={navigateToUserDetails}
      />
    ))
  );
};
